/* audit_policy_failed.icon.svg.js */

module.exports = {
    icon: `<svg viewBox="0 0 19 19" preserveAspectRatio="none"><path class="foreground-gl" d="M13.7,1.8h-2.9C10.5,0.8,9.6,0,8.4,0S6.3,0.8,6,1.8H3.2c-1,0-1.7,0.8-1.7,1.7v13.3c0,1,0.8,1.7,1.7,1.7h4
\tc-0.2-0.1-0.3-0.1-0.6-0.3C6.3,18,6.1,17.7,6,17.4H3.4c-0.3,0-0.7-0.3-0.7-0.6V3.6C2.7,3.2,2.9,3,3.3,3h0.9c0.1,0.7,0.3,2,1.4,2H11
\tc1.2,0,1.4-1.3,1.4-2h1.3c0.3,0,0.6,0.3,0.6,0.6v3.2l1.2-1V3.6C15.5,2.6,14.7,1.8,13.7,1.8z M6.9,2.5C6.9,1.7,7.6,1,8.4,1
\tC9.3,1,10,1.7,10,2.5v0.3H6.9C6.9,2.7,6.9,2.6,6.9,2.5z"/><path class="foreground-gl" d="M13.7,12.3l3.5-3.5c0.4-0.4,0.4-1.1,0-1.6c-0.4-0.4-1.1-0.4-1.6,0l-3.5,3.5L8.7,7.2c-0.4-0.4-1.1-0.4-1.6,0
\tc-0.4,0.4-0.4,1.1,0,1.6l3.5,3.5l-3.3,3.3c-0.4,0.4-0.4,1.1,0,1.6c0.2,0.2,0.5,0.3,0.8,0.3s0.6-0.1,0.8-0.3l3.2-3.3l3.2,3.3
\tc0.2,0.2,0.5,0.3,0.8,0.3c0.3,0,0.6-0.1,0.8-0.3c0.4-0.4,0.4-1.1,0-1.6L13.7,12.3z"/></svg>`
};
